export default {
  status: undefined,
  isLoadingUpdateLocale: false,
  isLoading2fa: false,
};
